/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: cuixinming
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import BulletScreen from "./relyon";
import Request from "../../utils/request";
import utils from "../../utils/utils";
import "./style.less";
const praised_icon = 'https://static.shihuocdn.cn/admin/files/20241029/ccb6c6caff2783d6ee264a93e088af3a.png'//选中后
const un_praised_icon = 'https://static.shihuocdn.cn/admin/files/20241030/3fb5328f73d6e71f26565f4cab026ce1.png'//未点赞
const praised_animated = 'https://static.shihuocdn.cn/admin/files/20241030/0b93aed2556da7d4fa0f20fd71a83687.svga'//点赞动效
const cancel_praised_animated = 'https://static.shihuocdn.cn/admin/files/20241030/04da2106cd39ebf948c4dc3d033b46ad.svga'//取消点赞

let startX = 0; // 初始触摸点的X坐标
let startY = 0; // 初始触摸点的Y坐标
let isSwiping = false; // 是否正在进行滑动手势
class PipelineInteractMessage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bulletList: [],
      randomUsers: [],
      count: 0,
      message: '',
      show_toast: false,
      toast_text: '',
      pageId: utils.getPageId()
    };
    this.BulletScreen = null;
    this.interval = null;
    this.inputRef = null;
    this.praiseRefMap = {};
    this.praiseImgRefMap = {};
  }

  componentDidMount() {
    this.getBulletList();
    this.initBulletScreen();
    // document.addEventListener("visibilitychange", () => {
    //   var string = document.visibilityState
    //   if (string === 'hidden') {
    //     this.BulletScreen.pause();
    //   }
    //   if (string === 'visible') {
    //     this.BulletScreen.resume();
    //   }
    // });

    // 添加事件监听器
    document.addEventListener('touchstart', this.handleTouchStart);
    document.addEventListener('touchmove', this.handleTouchMove);
    document.addEventListener('touchend', this.handleTouchEnd);

    this.peloadingSvg(praised_animated)

  }

  peloadingSvg = (url) => {//预加载图片资源
    if (this.praiseHiddenRef) {
      import('svgaplayerweb').then((SVGA) => {
        const player = new SVGA.Player(this.praiseHiddenRef);
        const parser = new SVGA.Parser(this.praiseHiddenRef); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
        parser.load(url, (videoItem) => {
          player.loops = 1;
          player.setVideoItem(videoItem);
          player.startAnimation();
          player.onFinished(() => {
            player.stopAnimation(true);
            if (url.includes('/0b93aed2556da7d4fa0f20fd71a83687')) {
              this.peloadingSvg(cancel_praised_animated)
            }
          });
        })
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const isAnchorInSwitchTab = this.props['customAttributes']["data-component-belong"] === 'tab';
    if (isAnchorInSwitchTab && (nextProps.tabActive != nextProps.tabIndex)) {
      if (this.BulletScreen) {
        this.BulletScreen.clear();
        this.BulletScreen.stop = true;
      }
    } else {
      if (this.BulletScreen) {
        this.BulletScreen.stop = false;
      }
    }

    if (nextProps.playerState === 'pause') {
      // 暂停播放
      if (this.BulletScreen) {
        this.BulletScreen.destory();
      }
    } else if (nextProps.playerState === 'play') {
      this.BulletScreen = null;
      this.initBulletScreen();
      this.resetBulletList();
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    this.interval = null;
    document.removeEventListener('touchstart', this.handleTouchStart);
    document.removeEventListener('touchmove', this.handleTouchMove);
    document.removeEventListener('touchend', this.handleTouchEnd);
  }

  resetBulletList = () => {
    const bulletList = this.state.bulletList;
    if (bulletList && bulletList.length > 0) {
      bulletList.forEach(item => {
        const bullet = {
          id: item.id,
          avatar: item.avatar,
          name: item.name,
          comment: item.comment,
          like_cnt: item.like_cnt,
          self_like: item.self_like,
          is_self: item.is_self,
          hot: item.hot
        }
        this.BulletScreen.push(
          this.renderStyledBullet(bullet)
        )
      });
    }
  }
  
  initBulletScreen = () => {
    this.BulletScreen = new BulletScreen(this.ref, {
      trackHeight: 40,
      onStart: (id, index, total) => {
        if (index === total - 1) {
          this.state.bulletList.forEach(item => {
            const bullet = {
              id: item.id,
              uid: item.uid,
              avatar: item.avatar,
              name: item.name,
              comment: item.comment,
              like_cnt: item.like_cnt,
              self_like: item.self_like,
              is_self: item.is_self,
              hot: item.hot
            }
            this.BulletScreen.push(
              this.renderStyledBullet(bullet)
            )
          });
        }
      },
      onEnd: (id, index) => {

      }
    });
  }

  handleTouchStart = (event) => {
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
    isSwiping = false;
  }

  handleTouchMove = (event) => {
    if (!startX || !startY) {
      return; // 未初始化或已经重置了起始点
    }
  
    const deltaX = event.touches[0].clientX - startX;
    const deltaY = event.touches[0].clientY - startY;
    
    // 判断滑动距离是否足够触发滑动手势
    if (Math.abs(deltaX) > 10 || Math.abs(deltaY) > 10) {
      isSwiping = true;
      this.inputRef && this.inputRef.blur();
    }
  }

  handleTouchEnd = () => {
    // 重置触摸点和滑动状态
    startX = 0;
    startY = 0;
    isSwiping = false;
  }

  scrollSmoothTo(position) {
    if (!window.requestAnimationFrame) {
      window.requestAnimationFrame = function (callback, element) {
        return setTimeout(callback, 17);
      };
    }
    // 当前滚动高度
    var scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    // 滚动step方法
    var step = function () {
      // 距离目标滚动距离
      var distance = position - scrollTop;
      // 目标滚动位置
      scrollTop = scrollTop + distance / 5;
      if (Math.abs(distance) < 1) {
        window.scrollTo(0, position);
      } else {
        window.scrollTo(0, scrollTop);
        requestAnimationFrame(step);
      }
    };
    step();
  }

  // 获取留言信息
  getBulletList = () => {
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/hot?access_token=znSnA7pxO35wtPBaur',
      method: "get",
      withCredentials: true,
      params: {
        page: 1,
        page_size: 50,
        pos: this.state.pageId,
      },
    }).then((res) => {
      const { status, data } = res.data;
      if (status === 0) {
        const list = data.list;
        const count = data.count;
        const randomUsers = this.getArrayItems(list, 3);
        const topThree = this.signLikeCntTopThree(list);
        topThree.forEach(item => {
          list.forEach(value => {
            if (value.like_cnt === item.like_cnt && value.like_cnt != 0) {
              value['hot'] = 1
            }
          })
        });
        this.setState({
          bulletList: list,
          randomUsers,
          count
        }, () => {
          list.forEach(item => {
            const bullet = {
              id: item.id,
              avatar: item.avatar,
              name: item.name,
              comment: item.comment,
              like_cnt: item.like_cnt,
              self_like: item.self_like,
              is_self: item.is_self,
              hot: item.hot
            }
            this.BulletScreen.push(
              this.renderStyledBullet(bullet)
            )
          });
        });
      }
    })
  }

  showPraiseSvga = (svgaUrl, id, bulletIndex) => {
    let praiseRef = window.document.getElementById(`praise-icon-svga-${id}`)
    let praiseIconRef = window.document.getElementById(`praise-icon-${id}`)
    console.log(id, '---showPraiseSvga1-',this.praiseRefMap, praiseRef, praiseIconRef)
    if (praiseRef) {
      const bulletList = this.state.bulletList;
      import('svgaplayerweb').then((SVGA) => {
        praiseRef.style.display = "flex";
        praiseIconRef.style.display = "none";
        const player = new SVGA.Player(`#praise-icon-svga-${id}`);
        const parser = new SVGA.Parser(`#praise-icon-svga-${id}`); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
        parser.load(svgaUrl, (videoItem) => {
          player.loops = 1;
          player.setVideoItem(videoItem);
          player.startAnimation();
          player.onFinished(() => {
            praiseRef.style.display = "none";
            this.BulletScreen._changeStatus(bulletList[bulletIndex].id, bulletList[bulletIndex].like_cnt, bulletList[bulletIndex].self_like)
            player.stopAnimation(true)
          });
        })
      });
    }
  }

  // 点赞与取消点赞
  handlePraise = async(e, bullet) => {
    const userCookie = await utils.getCookie('u');
    if (!userCookie) {
      window.Jockey.send('login');
      return;
    }
    const bulletList = this.state.bulletList;
    const bulletIndex = bulletList.findIndex(item => item.id === bullet.id);
    const toggleStatus = bulletList[bulletIndex].self_like ? 0 : 1; // 切换状态
    bulletList[bulletIndex].self_like = Boolean(toggleStatus);
    console.log('-handlePraise--', toggleStatus)
    if (toggleStatus === 1) {
      bulletList[bulletIndex].like_cnt += 1;
      this.showPraiseSvga(praised_animated, bullet.id, bulletIndex)
    } else {
      this.showPraiseSvga(cancel_praised_animated, bullet.id, bulletIndex)
      bulletList[bulletIndex].like_cnt -= 1;
    }
    if (userCookie) {
      this.setState({
        bulletList,
      });
      // 点赞与取消
      Request({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/like?access_token=znSnA7pxO35wtPBaur',
        method: "post",
        withCredentials: true,
        data: {
          comment_id: bulletList[bulletIndex].id,
          status: toggleStatus,
        },
      }).then((res) => {
        if (res.data.status === 0) {
          // 操作成功
        }
      });
    }
  }

  // 监听输入框变化
  handleMessageChange = (event) => {
    this.setState({
      message: event.target.value
    });
  }

  // 发布留言
  handleSendMessage = async() => {
    const { message, bulletList } = this.state;
    if (!message) {
      this.setState({
        show_toast: true,
        toast_text: '请输入留言信息'
      });
      return;
    }

    const userCookie = await utils.getCookie('u');
    if (userCookie) {
      Request({
        url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/comment/save?access_token=znSnA7pxO35wtPBaur',
        method: "post",
        withCredentials: true,
        data: {
          comment: message,
          pos: this.state.pageId,
        },
      }).then((res) => {
        if (res.data.status === 0) {
          // 将新发布的一条消息推入列表
          const { id, name, avatar, comment, like_cnt, self_like } = res.data.data.comment;
          const option = {
            id: id,
            avatar: avatar,
            name: name,
            comment: comment,
            like_cnt: like_cnt,
            self_like: self_like,
            is_self: 1
          }
          this.BulletScreen.push(
            this.renderStyledBullet(option), 
            {},
            'unshift'
          )
          bulletList.push(option);
          this.setState({
            bulletList,
            message: '',
            show_toast: true,
            toast_text: '留言发布成功',
          });
        } else {
          this.setState({
            show_toast: true,
            toast_text: res.data.msg
          });
        }
      })
    } else if (typeof window !== 'undefined'){
      window.Jockey.send('login');
    }
  }

  removeDuplicate(arr) {
    const map = {};
    const result = [];
    for (var i = 0; i < arr.length; i++) {
      var item = arr[i];
      if (!map[item.name]) {
        map[item.name] = true; // 标记id已经出现过
        result.push(item);
      }
    }
    return result;
  }

  // 获取点赞前三的评论
  signLikeCntTopThree(arr){
    return arr.map(function (item,i) {     //  重构，将数组每项绑定相应索引
      return {
        index: i,
        like_cnt: item.like_cnt
      }
    })
    .sort(function (a,b) {     //  排序，根据每项数值排序
      return b.like_cnt - a.like_cnt;
    })
    .filter(function (item,i) {     //  筛选，获取排序后前三项
      return i < 3
    })
    .map(function (item) {     //  提取，获取前三项原始索引
      return item
    });
  }

  getUserName = (username = '') => {
    if (username.length <= 0) {
      return 'C*o'
    } else if (username.length > 0 && username.length < 2) {
      return username;
    } else if (username.length === 2) {
      const firstChar = username[0];
      username = firstChar + '*';
      return username;
    } else {
      const firstChar = username[0];  
      const lastChar = username[username.length - 1];
      username = firstChar + '*' + lastChar;
      return username;
    }
  }

  handleItemClick = () => {
    const href = `shihuo://www.shihuo.cn?route=RNProgram&miniId=Shihuo_Activity&page=InteractionMessage&options=${encodeURIComponent(JSON.stringify({pageId: this.state.pageId}))}`
    utils.jumpToUrl(this.props.routeParams, href, href, {}, -1, this.props);
  }

  // 渲染留言弹幕
  renderStyledBullet(bullet) {
    const { styleConfig = {} } = this.props.config;
    const { id, avatar, name, comment, like_cnt, self_like, hot, is_self } = bullet;
    return (
      <div 
        className={`bullet-item bullet-item-${id} ${hot == 1 ? 'hot' : ''} ${is_self == 1 ? 'active' : ''}`}
        style={{
          color: styleConfig.barrageTextColor, 
          background: `linear-gradient(90deg, ${utils.hexColorToRgba(styleConfig.barrageBgColorFrom, is_self == 1 ? 1 : 0.7)} 0%, ${utils.hexColorToRgba(styleConfig.barrageBgColorTo, is_self == 1 ? 1 : 0.7)} 100%)`
        }}>
        { hot == 1 && <img src="https://static.shihuocdn.cn/admin/files/20240220/eaf51770a87e6db641054a93b272efd7.png" alt="" className="hot-tag" /> }
        <img src={avatar || 'https://static.shihuocdn.cn/admin/files/20240220/fedaec1a685a6b957fef5d37a7efb899.png'} alt="" className="avatar" />
        <p className="nickname">{this.getUserName(name)}{is_self == 1 && '(我)'}：</p>
        <p className="message">{comment.length > 12 ? comment.slice(0, 12) + '...' : comment}</p>
        <div className="praise">
          <div className="praise-icon-content">
            <div className="self-like">
              <img
                src={!self_like ? un_praised_icon : praised_icon}
                alt=""
                className="icon"
                ref={r => { this.praiseImgRefMap[id] = r }}
                id={`praise-icon-${id}`}
              />
            </div>
            <div
              className="praise-icon-svga"
            >
              <div style={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }} id={`praise-icon-svga-${id}`} ref={r => { this.praiseRefMap[id] = r }} />
            </div>
          </div>
          <p className="like-cnt">{like_cnt > 0 ? like_cnt : ''}</p>
        </div>
        <div className="praise-cover" onClick={(e) => this.handlePraise(e, bullet)}></div>
      </div>
    )
  }

  render() {
    const { baseConfig = {}, styleConfig ={} } = this.props.config;
    const { backgroundColorType, backgroundColor, messagefuncBackgroundColor, backgroundImage } = styleConfig || {};
    const { message, randomUsers = [], count } = this.state;
    const contentStyle = 
      backgroundColorType == "纯色背景"
      ? { backgroundColor: backgroundColor }
      : backgroundColorType == "图片背景"
      ? { backgroundImage: `url(${backgroundImage})` }
      : {}
    const inputStyle = { backgroundColor: backgroundColorType == "纯色背景" ? messagefuncBackgroundColor : "transparent" }
    return (
      <div
        ref={ele => {
          if (ele) {
            this.props.exp && this.props.exp(ele);
          }
        }}
        data-dot={JSON.stringify(utils.getExposureData(this.props))}
        className="pipeline-interactMessage"
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`,
          marginBottom: this.props.showCompMarginBottom ? '8px' : '0px'
        }}
      >
        <div className="content" style={contentStyle}>
          <div className="header" style={{color: styleConfig.titleColor}}>
            <div className="title-info">
              <p className="title-name">评论留言区</p>
              {
                count > 10 && (
                  <div className="users">
                    <div className="user-avatar">
                      {
                        randomUsers.map((item, index) => {
                          return <img src={item.avatar || 'https://static.shihuocdn.cn/admin/files/20240220/fedaec1a685a6b957fef5d37a7efb899.png'} alt="" key={index} className={`img-${index + 1}`} />
                        })
                      }
                    </div>
                    { count && <p className="join-num">{count}人参与</p> }
                  </div>
                )
              }
            </div>
            <div className="more" onClick={() => this.handleItemClick()}>
              查看更多
              <svg t="1680593620629" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="2293" width="12" height="12">
                <path d="M346.453333 927.957333a42.666667 42.666667 0 0 1-63.786666-56.448l3.541333-4.010666L640 515.072 286.122667 159.872A42.666667 42.666667 0 0 1 342.570667 96l4.010666 3.541333 353.877334 355.285334a85.333333 85.333333 0 0 1 4.778666 115.285333l-5.034666 5.418667-353.749334 352.384z" p-id="2294" fill={styleConfig.titleColor}></path>
              </svg>
            </div>
          </div>
          <div className="screen" ref={ref => this.ref = ref}>
            <p className="tips">一大波留言正在来袭...</p>
          </div>
          <div className="send-message"  style={inputStyle}>
            <div className="input-message">
              <svg t="1680593264243" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="https://www.w3.org/2000/svg" p-id="2099" width="16" height="16">
                <path d="M793.344 822.848a34.112 34.112 0 0 1 6.144 67.712l-6.144 0.576H520.32a34.112 34.112 0 0 1-6.144-67.712l6.144-0.576h273.024zM803.52 230.912l-48.256-48.256a102.4 102.4 0 0 0-144.832 0L219.008 574.08a102.4 102.4 0 0 0-26.368 45.44l-33.856 124.032a68.288 68.288 0 0 0 83.84 83.84l124.032-33.92a102.4 102.4 0 0 0 45.44-26.304l391.424-391.424a102.4 102.4 0 0 0 0-144.832z m-96.576 0l48.32 48.32a34.112 34.112 0 0 1 0 48.256l-391.424 391.36a34.112 34.112 0 0 1-15.168 8.832l-124.032 33.856 33.92-124.032a34.112 34.112 0 0 1 8.768-15.168l391.36-391.424a34.112 34.112 0 0 1 48.256 0z" p-id="2100" fill="#979797"></path>
              </svg>
              <input id="inputRef" ref={ref => this.inputRef = ref} type="text" placeholder={styleConfig.inputPlaceholder || '留言弹幕，和大家互动起来'} value={message} onChange={this.handleMessageChange}/>
            </div>
            {
              styleConfig.sendMessageBtnImage ? (
                <img src={styleConfig.sendMessageBtnImage} alt="" className="send-btn-img" onClick={() => this.handleSendMessage()} />
              ) : (
                <div
                  className="send-btn"
                  onClick={() => this.handleSendMessage()}
                  style={{
                    backgroundColor: styleConfig.sendMessageBtnBgColor,
                    color: styleConfig.sendMessageBtnTextColor,
                  }}
                >
                  发送
                </div>
              )
            }
          </div>
          { this.renderToast() }
          <div style={{ width: 0, height: 0, overflow: 'hidden', position: 'absolute', left: 0, top: 0}} ref={ref => this.praiseHiddenRef = ref} />
        </div>
      </div>
    )
  }

  // 渲染Toast
  renderToast = () => {
    const { show_toast, toast_text } = this.state;
    if (show_toast) {
      this.interval && clearTimeout(this.interval);
      this.interval = setTimeout(() => {
        this.setState({
          show_toast: false,
          toast_text: ''
        });
      }, 3000);
      return <p className="toast">{toast_text}</p>;
    } else {
      return null;
    }
  }

  // 随机取3个用户的信息
  getArrayItems = (arr, num) => {
    arr = this.removeDuplicate(arr)
    //新建一个数组,将传入的数组复制过来,用于运算,而不要直接操作传入的数组;
    const temp_array = new Array();
    for (const index in arr) {
      temp_array.push(arr[index]);
    }
    //取出的数值项,保存在此数组
    const return_array = new Array();
    for (let i = 0; i < num; i++) {
      //判断如果数组还有可以取出的元素,以防下标越界
      if (temp_array.length>0) {
        //在数组中产生一个随机索引
        const arrIndex = Math.floor(Math.random() * temp_array.length);
        //将此随机索引的对应的数组元素值复制出来
        return_array[i] = temp_array[arrIndex];
        //然后删掉此索引的数组元素,这时候temp_array变为新的数组
        temp_array.splice(arrIndex, 1);
      } else {
        //数组中数据项取完后,退出循环,比如数组本来只有10项,但要求取出20项.
        break;
      }
    }
    return return_array;
  }
}

export { PipelineInteractMessage };
export default PipelineInteractMessage;



// WEBPACK FOOTER //
// ./components/pipeline-interactMessage/index.js